import React from "react";
import { SingleBody, SingleWrapper } from "../";

/**
 * a global layout to render every page
 *
 */

function Single({ children }) {
	return (
		<SingleWrapper>
			<SingleBody children={children} />
		</SingleWrapper>
	);
}

export default Single;
